import { IAlertProps, P2GAlert } from '@parcel2go/core-ui';

const FullWidthAlert = (props: IAlertProps) => (
  <P2GAlert sx={{ '& .MuiAlert-message': { width: '100%' } }} {...props} />
);

export default FullWidthAlert;
